"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vadena": {
    "ff4edd74": [{
      "hkey": "65dd0eae",
      "slug": "vadena",
      "name": "Vadena",
      "primary": true,
      "skipSearch": false
    }],
    "piccolongo": [{
      "hkey": "65dd0eae",
      "slug": "vadena",
      "name": "Vadena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;